/**
 * SettingsForm - API 키 설정 폼 컴포넌트
 *
 * Phase 1 리팩토링: Settings.tsx에서 분리
 */
import React from 'react';

interface SettingsFormProps {
  apiKey: string;
  setApiKey: (value: string) => void;
  secretKey: string;
  setSecretKey: (value: string) => void;
  saving: boolean;
  onSubmit: (e: React.FormEvent) => void;
}

const SettingsForm: React.FC<SettingsFormProps> = ({
  apiKey,
  setApiKey,
  secretKey,
  setSecretKey,
  saving,
  onSubmit,
}) => {
  return (
    <form onSubmit={onSubmit} className="settings-form">
      <div className="form-group">
        <label htmlFor="apiKey">Alpaca API Key</label>
        <input
          type="text"
          id="apiKey"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="PK..."
          className="form-input"
        />
        <small>새 키를 입력하면 기존 키를 덮어씁니다</small>
      </div>

      <div className="form-group">
        <label htmlFor="secretKey">Alpaca Secret Key</label>
        <input
          type="password"
          id="secretKey"
          value={secretKey}
          onChange={(e) => setSecretKey(e.target.value)}
          placeholder="SK..."
          className="form-input"
        />
        <small>암호화하여 저장됩니다</small>
      </div>

      <button type="submit" disabled={saving} className="save-button">
        {saving ? '저장 중...' : '저장'}
      </button>
    </form>
  );
};

export default SettingsForm;
